import { getIsAssetEditableInHub } from 'utils/privileges/getIsAssetEditableInHub';
import { getIsPlaylistEditable } from 'utils/privileges/getIsPlaylistEditable';
import config from 'utils/config';
import { hasPrivilege, isTeamManager } from 'utils/privileges';
export function checkIsItemEditable(_ref) {
  var item = _ref.item,
    parentPlaylistMemberContributions = _ref.parentPlaylistMemberContributions,
    parentPlaylistOwnerTeamId = _ref.parentPlaylistOwnerTeamId;
  var hasMemberContributionsEnabled = parentPlaylistMemberContributions && config.memberContributions;
  if (item.type === 'playlist') {
    return getIsPlaylistEditable(item, true);
  } else if (item.type === 'section') {
    return hasPrivilege('playlist_write') || parentPlaylistOwnerTeamId && isTeamManager(parentPlaylistOwnerTeamId);
  } else {
    var _item$author;
    // asset check
    return getIsAssetEditableInHub({
      ownerTeamId: item.ownerTeamId,
      domain_id: item.domain_id,
      allowEditingDistributedPlaylists: true,
      authorId: hasMemberContributionsEnabled && ((_item$author = item.author) === null || _item$author === void 0 ? void 0 : _item$author.id)
    });
  }
}